module.exports = __webpack_public_path__ + "static/img/bracelets-spec.a59b4ae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bracelets-spec.jpg
// module id = 1AGz
// module chunks = 1